import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {BaseComponent, Message} from 'iui-iconectiv-lib';
import {Tier} from "../model";
import {FeeScheduleService} from "./fee-schedule.service";


@Component({
  selector: 'fee-schedule',
  templateUrl: './fee-schedule.component.html',
  styleUrls: ['./fee-schedule.component.scss'],
})


export class FeeScheduleComponent extends BaseComponent implements OnInit {

  @Input() selectedTier: string;
  @Input() disabled: boolean = false;
  @Output() selectedTierChange: EventEmitter<string> = new EventEmitter<string>();

  tiers: Tier[];
  headers: any[];

  constructor(private feeScheduleService: FeeScheduleService) {
    super();

    this.headers = [
      {header: 'Usage Tier', width: '15'},
      {header: 'Monthly Fee', width: '22'},
      {header: 'Lookup Allowance', width: '30'},
      {header: 'Overage Charge', width: '22'},
      {header: '', width: '5'},
    ];
  }

  ngOnInit(): void {
    this.initTiers()
  }

  initTiers() {
    this.feeScheduleService.getFeeScheduleList().subscribe(
      resp => {
        if (resp['status'] === 'fail') {
          // prepare error message
          const message: any = resp['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.log.error(`feeScheduleList(): errorMessage=${errorMessage}`);
          this.displayError();

        } else {
          var fees = resp['feeSchedule'] || null;

          if (fees === null) {
            this.log.error(`feeScheduleList(): fee schedule list is empty`);
            this.displayError();
          }
          else {
            this.composeLabelsFromNames(fees);
            this.tiers = fees;

            this.tiers.sort( function(tier1, tier2) {
              if ( tier1.tierName < tier2.tierName ){
                return -1;
              }else if( tier1.tierName > tier2.tierName ){
                  return 1;
              }else{
                return 0;	
              }
          });
          }
        }
      },
      error => {
        this.log.error(`feeScheduleList(): got HttpError=${JSON.stringify(error)}`);
        this.displayError();
      }
    );
  }

  composeLabelsFromNames(fees: Tier[]) {
    fees.map(function (tier) {
      tier.label = tier.tierName.replace(/([^0-9])([0-9])/g, '$1 $2') //Tier1 -> Tier 1
      return tier;
    });
  }

  displayError() {
    this.displayErrorMessage(
      new Message('Error', 'The system was unsuccessful in processing your request. Please try again, or contact Customer Support for assistance.')
    );
  }

  onTierChange(tier: string) {
    this.selectedTierChange.emit(tier);
  }
}
